exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Policies-root-HC6K7 {\n  padding-left: 0px;\n  padding-right: 0px;\n}\n\n.Policies-container-3RYV8 {\n  margin: 0px auto;\n  padding: 0 0 40px;\n  margin-top: 30px;\n  max-width: var(--max-content-width);\n}", ""]);

// exports
exports.locals = {
	"root": "Policies-root-HC6K7",
	"container": "Policies-container-3RYV8"
};